/** Events per stored chunk. A save rewrites only the chunks that changed. */
export const PLAYBACK_QUEUE_CHUNK_SIZE = 1000;
/** The stored queue exists but can't be read as a queue. Retrying the load won't help. */
export class InvalidPlaybackQueueSnapshotError extends Error {
    discardedEvents;
    constructor(message, 
    /** How many events the unreadable snapshot held, counted as dropped. */
    discardedEvents = 0) {
        super(message);
        this.discardedEvents = discardedEvents;
        this.name = 'InvalidPlaybackQueueSnapshotError';
    }
}
//# sourceMappingURL=playback-event-store.js.map